import {
	TRACKING_HISTORY_LOADING_TRUE,
	TRACKING_HISTORY_LOADING_FALSE,
	TRACKING_HISTORY_GET,
	TRACKING_HISTORY_ERROR,
	TRACKING_OVERVIEW_LOADING_TRUE,
	TRACKING_OVERVIEW_LOADING_FALSE,
	TRACKING_OVERVIEW_GET,
	TRACKING_OVERVIEW_ERROR,
	ROUTE_SCHEDULE_LOADING_TRUE,
	ROUTE_SCHEDULE_LOADING_FALSE,
	ROUTE_SCHEDULE_GET,
	ROUTE_SCHEDULE_ERROR
} from '../actions/types';

const initialState = {
	loading: false,
	history: [],
	error: null,
	overviewLoading: false,
	overview: [],
	overviewCount: 0,
	overviewError: null,
	scheduleLoading: false,
	schedule: [],
	scheduleMeta: { total: 0, count: 0, missing: 0, frequency: null, route: null },
	scheduleError: null
}

export default function(state = initialState, action) {
	switch(action.type) {
		case TRACKING_HISTORY_LOADING_TRUE:
			return {
				...state,
				loading: true
			}
		case TRACKING_HISTORY_LOADING_FALSE:
			return {
				...state,
				loading: false
			}
		case TRACKING_HISTORY_GET:
			return {
				...state,
				history: action.payload.locations || action.payload.history || action.payload,
				error: null
			}
		case TRACKING_HISTORY_ERROR:
			return {
				...state,
				error: action.payload
			}
		case TRACKING_OVERVIEW_LOADING_TRUE:
			return {
				...state,
				overviewLoading: true
			}
		case TRACKING_OVERVIEW_LOADING_FALSE:
			return {
				...state,
				overviewLoading: false
			}
		case TRACKING_OVERVIEW_GET:
			return {
				...state,
				overview: action.payload.locations || [],
				overviewCount: action.payload.count || 0,
				overviewError: null
			}
		case TRACKING_OVERVIEW_ERROR:
			return {
				...state,
				overviewError: action.payload
			}
		case ROUTE_SCHEDULE_LOADING_TRUE:
			return {
				...state,
				scheduleLoading: true
			}
		case ROUTE_SCHEDULE_LOADING_FALSE:
			return {
				...state,
				scheduleLoading: false
			}
		case ROUTE_SCHEDULE_GET:
			return {
				...state,
				schedule: action.payload?.locations || [],
				scheduleMeta: {
					total: action.payload?.total ?? 0,
					count: action.payload?.count ?? 0,
					missing: action.payload?.missing ?? 0,
					frequency: action.payload?.frequency ?? null,
					route: action.payload?.route ?? null
				},
				scheduleError: null
			}
		case ROUTE_SCHEDULE_ERROR:
			return {
				...state,
				scheduleError: action.payload
			}
		default:
			return state;
	}
}
